import React from "react";

const RichText = ({
  heading,
  text,
  bordered = false,
  textAlign = "center",
}) => {
  return (
    <div className="bg-black py-12">
      <div
        className={`max-w-[1152px] mx-auto p-6 ${
          bordered ? "border-2 border-[#BD0E0E]" : ""
        }`}
      >
        <h2 className="text-2xl font-bold mb-4 text-center text-white">
          {heading}
        </h2>
        <p
          className={`pl-5 pr-5 text-lg leading-relaxed text-${textAlign} text-white`}
        >
          {text}
        </p>
      </div>
    </div>
  );
};

export default RichText;
